module.exports = __webpack_public_path__ + "bb627ee595681ba2869221d3473e43b4.pdf";